import {
  SET_COUPON_MODAL_IS_VISIBLE,
  COUPON_POST_SUCCESS,
  SET_IS_REQUESTING,
  ADD_NEW_PROMO_CODE,
  SET_INVALID_PROMO_CODE,
  SET_VALID_PROMO_CODE,
  SET_PROMO_CODE,
} from './couponsTypes';

const initialState = {
  couponsModalIsVisible: false,
  couponType: '',
  couponValue: '',
  isRequesting: false,
  promoCodes: [],
  isValidPromocode: true,
  promoType: '',
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_COUPON_MODAL_IS_VISIBLE:
      return {
        ...state,
        promoType: action.promoType,
        couponsModalIsVisible: action.isCouponModalVisible,
        isValidPromocode: !action.isCouponModalVisible
          ? true
          : state.isValidPromocode,
      };
    case SET_IS_REQUESTING:
      return {
        ...state,
        isRequesting: action.boolean,
      };
    case COUPON_POST_SUCCESS:
      return {
        ...state,
        couponType: action.couponType,
        couponValue: action.couponValue,
        snackBarIsVisible: true,
        couponsModalIsVisible: false,
        isRequesting: false,
      };
    case ADD_NEW_PROMO_CODE:
      return {
        ...state,
        promoCodes: [...state.promoCodes, action.promoCode],
      };
    case SET_INVALID_PROMO_CODE:
      return {
        ...state,
        isValidPromocode: false,
      };
    case SET_VALID_PROMO_CODE:
      return {
        ...state,
        isValidPromocode: true,
        couponsModalIsVisible: false,
      };
    case SET_PROMO_CODE:
      return {
        ...state,
        promoCodes: action.promoCodes,
      };
    default:
      return state;
  }
}
